<template>
  <!-- Begin NER List -->
  <div class="flex justify-around items-center p-0 mb-1 rounded" :style="{background: backgroundColor}">
    <input type="text" disabled v-model="manualEdit" class=" w-1/2 bg-gray-200 text-sm m-1 rounded px-1"></input>
    <select 
      :disabled="!editList" 
      class="flex-shrink-0 w-32 bg-gray-200 border border-gray-200 text-sm text-gray-700 m-1 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
      v-model="selection">
      <option v-for="(item, index) in dropdownContent" :key="index" :value="item.name" class="text-sm" :selected="selection === item.name">{{ item.name }}</option>
    </select>

    <button class="focus:outline-none m-1" v-if="!editList" @click="editTheList">
      <i class="fas fa-edit text-xl text-blue-300 hover:text-blue-500"></i>
    </button>
    <button class="focus:outline-none m-1" v-else @click="submitEditting">
      <i class="fas fa-check-square text-xl text-green-300 hover:text-green-500"></i>
    </button>

    <button @click="deleteNERList(index)" class="border m-1 border-white flex-shrink-0 w-6 h-6 rounded-full bg-red-500 focus:outline-none hover:bg-red-700 flex items-center justify-center">
      <i class="fas fa-minus text-xl text-white"></i>
    </button>
  </div>
  <!-- End of NER List -->
</template>

<script>
import entityTypes from '@/entityTypes';
import { getTheWordCoordinate } from '@/helpers';

export default {
  data() {
    return {
      editList: true,
      selection: '',
      manualEdit: 'No Highlighted Data',
      renderComponent: false,
    }
  },
  props: [
    'data',
    'dropdownContent', 
    'deleteNERList', 
    'index', 
    'startEditingNERListProcess',
    'finishEditingNERListProcess',
    'fullText'
  ],
  computed: {
    backgroundColor() {
      const bgcolor = entityTypes.filter(item => item.name === this.data.entity_type);
      if (bgcolor.length > 0) {
        return bgcolor[0].color
      } else {
        return '#fff'
      }
    }
  },
  created() {
    this.selection = this.data.entity_type;
    this.manualEdit = this.data.namedEntity;
    
    if (this.data.namedEntity) {
      this.editList = false;
    }
  },
  methods: {
    editTheList() {
      this.editList = true;
      this.startEditingNERListProcess(this.index);
    },
    submitEditting() {
      this.editList = false;
      const index = getTheWordCoordinate(this.fullText, this.manualEdit);
      const data = { id: this.data.id, entity_type: this.selection, namedEntity: this.manualEdit, index }
      this.finishEditingNERListProcess(this.index, data);
    }
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        this.manualEdit = this.data.namedEntity;
      },
      deep: true
    },
  }
}
</script>

<style>

</style>